var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"请选择医生"},on:{"change":_vm.handleSelect},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.realName,"value":item.doctorId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }